import React from 'react';

function BackArrow() {
  return (
    <svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.13184 4.81348L5.50684 0.438477C5.83496 0.0830078 6.40918 0.0830078 6.7373 0.438477C7.09277 0.766602 7.09277 1.34082 6.7373 1.66895L3.86621 4.54004H12.2607C12.7256 4.54004 13.1357 4.9502 13.1357 5.41504C13.1357 5.90723 12.7256 6.29004 12.2607 6.29004H3.86621L6.7373 9.18848C7.09277 9.5166 7.09277 10.0908 6.7373 10.4189C6.40918 10.7744 5.83496 10.7744 5.50684 10.4189L1.13184 6.04395C0.776367 5.71582 0.776367 5.1416 1.13184 4.81348Z"
        fill="#667085"
      />
    </svg>
  );
}
export default BackArrow;
